import { render } from "./PurchaseOrder.vue?vue&type=template&id=0fb528cc&scoped=true"
import script from "./PurchaseOrder.vue?vue&type=script&lang=ts"
export * from "./PurchaseOrder.vue?vue&type=script&lang=ts"

import "./PurchaseOrder.vue?vue&type=style&index=0&id=0fb528cc&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0fb528cc"

export default script